module.exports = __webpack_public_path__ + "img/dashboard-avatar.4c759b1f.svg";